import(/* webpackMode: "eager" */ "/vercel/path0/src/app/[locale]/(feed)/news/page.tsx");
